import {useTranslation} from 'react-i18next'
import classes from './AuthStyles.module.scss'

export function SupportEmail() {
  const {t, i18n} = useTranslation()

  return (
    <p>
      {t('login.input.email')}{' '}
      <span className={classes.auth__footer__email}>{t('login.support_email')}</span>{' '}
      {t('login.support_text')}
    </p>
  )
}
